export default {
    workOrder_createEdit_low: "Low",
    workOrder_createEdit_medium: "Medium",
    workOrder_createEdit_high: "High",
    workOrder_createEdit_scheduledAt: "Scheduled At",
    workOrder_createEdit_customerLocation: "Customer and Location",
    workOrder_createEdit_type: "Type",
    workOrder_createEdit_formName: "Form Name",
    workOrder_createEdit_estimatedDuration: "Estimated Duration (minutes)",
    workOrder_createEdit_severity: "Severity",
    workOrder_createEdit_driver: "Driver",
    workOrder_createEdit_description: "Description",
    workOrder_createEdit_success: "Work order saved",
    workOrder_createEdit_unit: "Unit",
    workOrder_createEdit_unasigned: "Unasigned",
    workOrder_createEdit_status: "Status",
    workOrder_createEdit_closeDate: "Close Date",
    workOrder_createEdit_scheduledDateError: "Scheduled Date is less than the current date",
    workOrder_createEdit_formError: "Change the work order type and try again",
    workOrder_createEdit_dateError: "Scheduled date must be greater than current date",
    workOrder_createEdit_driverError: "The driver is not available in that time range",
};